import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEcommerceState } from '../interfaces/ecommerce--state.interface';
import { EcommerceProduct } from '../interfaces/ecommerce-product.interface';

const ecommerceState: IEcommerceState = {
  cart: [],
  viewed: []
};

export const ecommerceSlice = createSlice({
  name: "ecommerce",
  initialState: ecommerceState,
  reducers: {
    reviewProduct: (state, action: PayloadAction<EcommerceProduct>) => {
      state.viewed.push(action.payload);
    },
  
    addProductToCart: (state, action: PayloadAction<EcommerceProduct>) => {
      state.cart.push(action.payload);
    },
  
    removeLastProductFromCart: (state) => {
      state.cart.pop();
    },
  
    purchaseProducts: (state) => {
      state.cart = [];
    }
  }
});

export const { reviewProduct, addProductToCart, removeLastProductFromCart, purchaseProducts } = ecommerceSlice.actions;
export default ecommerceSlice.reducer;